import React from "react"
import CustomReactTable from "components/Templates/CustomReactTable"
import StyledLink from "components/Atoms/StyledLink"
import { useSearchFilter } from "hooks/searchFilterHooks"
import { useDCList } from "graphql/stock-summary/stock-summary.hooks"

const DCList = () => {
  const [{ date }] = useSearchFilter()
  const { data, loading } = useDCList()

  const COLUMNS = [
    {
      Header: "DC Name",
      accessor: "dc",
      minWidth: 200,
      Cell({ value }) {
        return (
          <StyledLink to={`/d/ecom/summary-stock/${value?.id}?date=${date}`}>
            {value?.name}
          </StyledLink>
        )
      },
    },
    {
      Header: "Opening",
      accessor: "opening",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Inwarded",
      accessor: "inwarded",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "In transit",
      accessor: "inTransit",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Delivered",
      accessor: "delivered",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Return",
      accessor: "returned",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Direct sale",
      accessor: "directSale",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Disposal",
      accessor: "disposal",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Closing",
      accessor: "closing",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
  ]
  return (
    <CustomReactTable
      loading={loading}
      loadingText="Fetching data"
      data={data?.dcWiseAggregateVisibility ?? []}
      columns={COLUMNS}
    />
  )
}

export default DCList
